import {
  BudgetAll
} from "../../../API/api.js";
import { thousandSplit } from "../../../util/util";
import moment from "moment"
export default {
  components: {},
  props:{
    projectInfo:Object

  },
  data() {
    return {
      listLabel: [
        {label: '', prop: 'title'},
                  

    ],
    listLabelTwo:[],
    loadingTop:true,
    loadingBottm:true,
    // 表格数据  (随意写的数据）
    tableData: [
      {
       
        title: '预计收入',
        prop:'sumEstimatedRevenue',
      },
      {
       
        title: '预计人效',
        prop:'sumEstimatedInvestmentAmount',
      },
      {
        title: '预计外发预算',
        prop:'sumEstimatedOutgoingAmount',

      },
      {
        title: '预计毛利润1',
        prop:'sumEstimatedGrossProfit',

      },
      {
        title: '预计毛利率1',
        prop:'estimatedGrossProfitRate',

      },
      {
        title: '预计毛利润2',
        prop:'sumEstimatedGrossProfit2',

      },
      {
        title: '预计毛利率2',
        prop:'estimatedGrossProfitRate2',

      },
      {
        prop:'sumActualPersonnelInput',
        title: '实际人员投入',
      },
      {
        prop:'sumRealIncome',
        title: '实际收入',
      },{
        prop:'sumActualOutgoingAmount',
        title: '实际外发金额',
      },
      {
        prop:'sumActualGrossProfit',
        title: '实际毛利润1',
      },
      {
        prop:'actualGrossProfitRate',
        title: '实际毛利率1',
      },
      {
        prop:'sumActualGrossProfit2',
        title: '实际毛利润2',
      },
      {
        prop:'actualGrossProfitRate2',
        title: '实际毛利率2',
      },
      {
        prop:'sumActualHumanEfficiency',
        title: '实际人效',
      },
    ],
    searchParams: {
      limit: 10,
      page: 1,
      pId: this.projectInfo.projectId==undefined?this.$route.query.id:this.projectInfo.projectId
    },
    allTotal:null,
    tableDataBottom:[],
    showAddAndEditBtn:false,//控制新增编辑权限
    showBudget:false,//控制项目预算是否展示
    }
  },
  watch: {

  },
  methods: {
    getPermiss(){
      let params={
        projectId:this.projectInfo.projectId==undefined?this.$route.query.id:this.projectInfo.projectId
      }
      this.$http
      .post(BudgetAll.getPermiss, this.qs.stringify(params))
      .then(res => {
        console.log(res,'res=====')
        const _data=res.data.retData;
        const _dataId=_data.map(obj=> obj.uid)
        console.log(_dataId,'=======',_dataId.indexOf(uId)!==-1);
        let uId=JSON.parse(localStorage.getItem("userInfo")).id
        if(_dataId.indexOf(uId)!==-1){
          this.showAddAndEditBtn=true;
        }
      })
    },
    currentChange(curpage) {
      console.log('123', curpage)
      this.searchParams.page = curpage;
      this.getProjectBudgetInfo();
    },
    prevClick(curpage) {
      this.searchParams.page = curpage;
      this.getProjectBudgetInfo();

    },
    nextClick(curpage) {
      this.searchParams.page = curpage;
      this.getProjectBudgetInfo();
    },
    addBuudget(){
      this.$router.push({
          path:'/projects/addBudget',
          query:{
            pId:this.projectInfo.projectId==undefined?this.$route.query.id:this.projectInfo.projectId,
            customerId:this.projectInfo.customerId==undefined?this.$route.query.customerId:this.projectInfo.customerId
          }
      });
     
  },
  goEdit(row){
    console.log(this.projectInfo,'projectInfo')
    this.$router.push({
      path:'/projects/addBudget',
      query:{
        dId:row.deliverablesId,
        pId:this.projectInfo.projectId==undefined?this.$route.query.id:this.projectInfo.projectId,
        customerId:this.projectInfo.customerId==undefined?this.$route.query.customerId:this.projectInfo.customerId 
      }
  });
      console.log(row,'row=======')  
  },
    //头部信息
    getAllInfo() {
      let params={
        pId:this.projectInfo.projectId==undefined?this.$route.query.id:this.projectInfo.projectId
      }
      this.$http
        .post(BudgetAll.getsumProjectBudgetById, this.qs.stringify(params))
        .then(res => {
          this.loadingTop=false;
          const data = res.data.retData;
          console.log(!data.length,'data===123',data.length,'data=====444')
          if(!data.length||data.length==0){
            this.tableData=[];
            this.listLabel=[];
          }else{
           
          for(let i of data){
            // const updateTime=new Date(i.updateDate);
            // const updateTitle=updateTime.getMonth()+1+'月'+updateTime.getDate()+'日'
            // const updateTitle = moment().format('MM月DD日')

            this.listLabel.push({
              label: i.strUpdateDate,
             
              prop:String(i.id)
            })

          };
          for (let i = 0; i < data.length; i++) {
          for(let j in this.tableData){
            let prop=this.tableData[j].prop;
            const money=data[i][prop];
            let arr=['actualGrossProfitRate','actualGrossProfitRate2','estimatedGrossProfitRate','estimatedGrossProfitRate2','sumEstimatedGrossProfitRate','sumEstimatedGrossProfitRate2','sumActualPersonnelInput','sumActualGrossProfitRate','sumActualGrossProfitRate2','sumActualHumanEfficiency'];
            //判断是否是金额，如果是就使用千位分隔符
           
            let newMoney
            if(arr.indexOf(prop)==-1){
            
               newMoney=this.formatMoney(money);
            
            }else{
              newMoney=money;
            }
            const sId=String(data[i].id)
            let obj = {
              // [`${data[i].id}`]: data[i][prop],
              [sId]: newMoney,
            }
           
            this.tableData[j] = {
              ...this.tableData[j],
              ...obj
            }
          }   
          }
        }
          console.log(this.tableData, ' this.tableData-----', this.listLabel,'this.listLabel')
        })
        .catch(res => {
          this.loadingTop = false;
          this.tableData=[];
          this.listLabel=[];
          console.log('hhhhh我是catch')
        });
      // 
    },
    //底部信息
    getProjectBudgetInfo(){
      this.tableDataBottom=[];
      this.$http
      .post(BudgetAll.getProjectBudgetInfo, this.qs.stringify(this.searchParams))
      .then(res => {
        this.loadingBottm=false;
        let data = res.data.retData;
        this.tableDataBottom=data.data;
        // this.allpeople=this.tableDataBottom.dailyHoursSummary
        this.allTotal=data.count
        this.loading = false;
        console.log(data,'data')
        // for(let j of data.data){
          // console.log(j,'j====')
          for(let i of data.data[0].dailyHoursSummary){
            // console.log(i,'i====')
          
            this.listLabelTwo.push({
              label:i.everyday,
              // summary:i,summary,
              prop:String(i.everyday),
            })
          }
         
           
        // }
        for(let i in this.tableDataBottom){
        
          for(let j of this.tableDataBottom[i].dailyHoursSummary){
           
          const sName=j.everyday;
          const sNumber=j.summary;
           let obj={
              [sName]:sNumber
            }
            
          this.tableDataBottom[i]={...this.tableDataBottom[i],...obj}
          }
          }
      })
      .catch(res => {
        this.loading = false;
      });
    },
  
    formatMoney(v) {
      let m = parseFloat(v);
      return isNaN(m) ? "0" : thousandSplit(m.toFixed(2) + "");
    },
    //表格数字格式化
    formatMoneyTable(row, col, money) {
      /* 先转数字固定小数，再转字符加千分位分隔符 */
      const m = parseFloat(money);
      return isNaN(m) ? "/" : thousandSplit(m.toFixed(2) + "");
    },
      //设置指定行、列、具体单元格颜色
      cellStyle({row, column, rowIndex, columnIndex}){
        if( columnIndex === 0){ //指定坐标rowIndex ：行，columnIndex ：列
        return 'background:#F2F2F2;font-weight:600;text-align:left' //rgb(105,0,7)
    }else{
        return 'text-align:right'

    }
    
  },
},
  mounted() {
    this.getAllInfo();
    this.getProjectBudgetInfo();
    this.getPermiss();
    this.$forceUpdate();
    // document.getElementsByClassName('creat_budget').style.visibility='visible' 
  },

}
